import React from 'react'
import Avatar from 'particles/Avatar'
import light from 'particles/themes/light'
import styled, { ThemeProvider } from 'particles/themes/styled'
import { CProfileState } from 'state/profile'
import Text from 'particles/Text'

interface PopupUserInfoProps {
    userInfos: CProfileState[]
}

const AvatarContainer = styled.div`
    display: flex;
    align-items: center;
    gap: ${({ theme }) => theme.spacing[100]};
    align-self: stretch;
    padding: 4px 0;
`

// FIXME: remove ThemeProvider once src/components/Tooltips.tsx component have been migrated
const PopupUserInfo: React.FC<PopupUserInfoProps> = ({ userInfos }) => {
    return (
        <ThemeProvider theme={light}>
            {userInfos.map(userInfo => {
                return (
                    <AvatarContainer key={userInfo.uuid}>
                        <Avatar profile={userInfo} />
                        <Text scale="bodyS400">{userInfo.name}</Text>
                    </AvatarContainer>
                )
            })}
        </ThemeProvider>
    )
}

export default PopupUserInfo
